import { NON_AUTHENTICATED_URLS } from "~/const/preAuthConsts";
import { RouteDef } from "./RouteSpecType";
import { lazyWithRetryAndPageAnalytics as retryLazy } from "./routesUtil";

// *** Lazy Page components ***
// Login
const Login = retryLazy(
    () => import("../Pages/PreAuthPages/LoginPage" /* webpackChunkName: "login", webpackPrefetch: true */),
);
const SSOSamlCallback = retryLazy(
    () => import("../Pages/PreAuthPages/SSOSamlCallback" /* webpackChunkName: "login" */),
);
const Unsubscribe = retryLazy(
    () => import("../Pages/PreAuthPages/Unsubscribe/UnsubscribePage" /* webpackChunkName: "unsubscribe" */),
);

const RedirectToOrgLogin = retryLazy(
    () => import("../Pages/PreAuthPages/RedirectToOrgLogin/RedirectToOrgLogin" /* webpackChunkName: "loginRedirect" */),
);

const preAuthRoutes: Array<RouteDef> = [
    // Login
    { path: NON_AUTHENTICATED_URLS.login, component: Login },
    {
        path: NON_AUTHENTICATED_URLS.reset_password,
        component: Login,
        props: { isResetPasswordMode: true },
    },
    {
        path: NON_AUTHENTICATED_URLS.confirm_registration,
        component: Login,
        props: { isConfirmRegistrationMode: true },
    },
    { path: NON_AUTHENTICATED_URLS.login_redirect, component: RedirectToOrgLogin },
    {
        path: NON_AUTHENTICATED_URLS.external_login_callback,
        component: SSOSamlCallback,
        props: { isLoginSuccess: false },
    },
    { path: NON_AUTHENTICATED_URLS.unsubscribe_report, component: Unsubscribe },
    { path: NON_AUTHENTICATED_URLS.unsubscribe_export, component: Unsubscribe },
];
export default preAuthRoutes;
